export const formatTotalScore = (arr: any[], maxLegs:number) => {
    const scores = [...arr]
    while (scores.length < maxLegs) {
        scores.push("");
    }
    return scores
}